const ITEMS = [
  "Resposta em segundos*",
  "Agendamento automático",
  "Confirmação anti-falta",
  "Recuperação de clientes",
  "Sua equipe no presencial",
  "Feito para o seu negócio",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-sm font-semibold uppercase tracking-[0.3em] text-petrol sm:text-base">
          {item}
        </span>
        <svg width="14" height="14" viewBox="0 0 14 14" className="shrink-0 text-turquoise" aria-hidden="true">
          <path d="M7 0L8.6 5.4L14 7L8.6 8.6L7 14L5.4 8.6L0 7L5.4 5.4Z" fill="currentColor" />
        </svg>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="marquee-strip"
      className="relative overflow-hidden border-y border-[var(--line)] bg-sage/60 py-5 dark:bg-petroldeep"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
